import { Route, Routes } from 'react-router-dom'
import Home from './Home'
import ShameList from './ShameList'
import About from './About'
import Search from './Search'
import Detail from './Detail'

const AppRouter = () => {
    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/shamelist' element={<ShameList />} />
            <Route path='/about' element={<About />} />
            <Route path='/search' element={<Search />} />
            <Route path='/detail/:id' element={<Detail />} />
        </Routes>
    )
}

export default AppRouter